import { useTranslation } from 'react-i18next'

export default function ExtensionPage() {
  const { t } = useTranslation()

  return (
    <div>
      {/* Hero */}
      <div className="ext-hero">
        <span className="coming-soon-badge">{t('comingSoon')}</span>
        <div className="ext-hero-title">{t('extension.heroTitle')}</div>
        <div className="ext-hero-sub">{t('extension.heroSub')}</div>
        <button className="btn-ext" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
          <svg viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" /></svg>
          {t('comingSoon')}
        </button>
      </div>

      {/* What to expect */}
      <div className="section-head">
        <span className="section-title">{t('extension.expectTitle')}</span>
      </div>
      <div className="three-col">
        <div className="info-card">
          <div className="info-card-header">
            <div className="info-card-icon"><svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg></div>
            <div className="info-card-title">{t('extension.feat1Title')}</div>
          </div>
          <div className="info-card-body">{t('extension.feat1Body')}</div>
        </div>
        <div className="info-card">
          <div className="info-card-header">
            <div className="info-card-icon"><svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" /></svg></div>
            <div className="info-card-title">{t('extension.feat2Title')}</div>
          </div>
          <div className="info-card-body">{t('extension.feat2Body')}</div>
        </div>
        <div className="info-card">
          <div className="info-card-header">
            <div className="info-card-icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20" /></svg></div>
            <div className="info-card-title">{t('extension.feat3Title')}</div>
          </div>
          <div className="info-card-body">{t('extension.feat3Body')}</div>
        </div>
      </div>
    </div>
  )
}
